import React from 'react';
import { useAppointmentDetailsContext } from '../contexts/appointmentdetails.context';
import { APIUtils } from '../../../../utils/apiutils';
import httpClient from '../../../../services/http';
import Swal from 'sweetalert2';
import TreatuLogo from '../../../../assets/logos/treatu_logo.png';
import { Button } from '@mui/material';

const PayNowBtn = () => {
    const { appointmentDetails, setAppointmentDetails } = useAppointmentDetailsContext();

    const retryPayment = async () => {
        try {
            Swal.showLoading();
            const url = APIUtils.getAPIEndpoint('retry-payment');
            const payload = { id: appointmentDetails.id, paymentStatus: 'PAID' };
            const { data } = await httpClient.post(url, payload);
            if (data.status === 'success') {
                Swal.fire(data.message, '', 'success');
                setAppointmentDetails(prev => ({...prev, paymentStatus: 'PAID'}));
            } else {
                Swal.fire(data.message, '', 'error');
            }
        } catch (error) {
            Swal.fire('Something went wrong!', '', 'error');
        } finally {
            Swal.hideLoading();
        }
    };

    const handlePayment = async () => {
        // Implement payment logic here
        try {
            const payload = {
                amount: appointmentDetails.amount,
                description: 'Appointment Booking',
                productName: 'Doctor Consultation',
                email: appointmentDetails.email,
                contact: appointmentDetails.mobile,
                personName: appointmentDetails.name
            };
            const orderData = await httpClient.post(APIUtils.getAPIEndpoint('create-order'), payload);
            const res = orderData?.data;
            if (res?.success) {
                const options = {
                    key: res.keyId,
                    amount: res.amount,
                    currency: 'INR',
                    name: res.product_name,
                    description: res.description,
                    image: TreatuLogo,
                    'order_id': res.orderId,
                    prefill: {
                        contact: res.contact,
                        name: res.name,
                        email: res.email
                    },
                    notes: {
                        description: res.description
                    },
                    theme: {
                        color: '#2300a3'
                    },
                    handler: response => {
                        console.log(response, 'response');
                        // if (response.status_code === 200) {
                        Swal.fire('Payment Success!', '', 'success');
                        retryPayment();
                        // } else {
                        //     Swal.fire('Payment Failed!', '', 'error');
                        // }
                    }
                };
                const razorpayObject = new window.Razorpay(options);
                razorpayObject.open();
            }
        } catch (error) {
            console.log(error);
            Swal.fire('Something Went Wrong!', '', 'error');
        } finally {
            Swal.hideLoading();
        }
    };

    return <Button color="primary" variant="contained" onClick={handlePayment}> Pay Now </Button>;
};

export default PayNowBtn;